export class AnalyticsClient {
    constructor(submitAnalyticsEventHandler) {
        this.initialize = () => { };
        this.submitEvent = (dto) => {
            this.submitAnalyticsEventHandler(Object.assign(Object.assign({}, dto), { context: {
                    url: window.location.href,
                    userAgent: window.navigator.userAgent,
                } }));
        };
        this.sendEvent = (eventDefinition, meta) => {
            this.submitEvent(Object.assign(Object.assign({}, eventDefinition), { meta }));
        };
        this.pageVisited = (eventDefinition, meta) => {
            this.submitEvent(Object.assign(Object.assign({}, eventDefinition), { action: 'page_visited', meta }));
        };
        this.submitAnalyticsEventHandler = submitAnalyticsEventHandler;
    }
}
